export default __webpack_public_path__ + "static/media/telephone.0bea3d96.jpeg";